// This file was auto-generated by Fern from our API Definition.
export const SessionOrigin = {
    Manual: "manual",
    Trigger: "trigger",
};
